/**
 * 예약 서비스
 */

import apiClient from './api';
import { Booking, BookingFilter, BookingListResponse } from '../types/booking';

export const bookingService = {
  /**
   * 예약 목록 조회
   */
  async getBookings(filter: BookingFilter = {}): Promise<BookingListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.date_from) params.append('date_from', filter.date_from);
    if (filter.date_to) params.append('date_to', filter.date_to);
    if (filter.booking_number) params.append('booking_number', filter.booking_number);
    if (filter.guest_name) params.append('guest_name', filter.guest_name);
    if (filter.guest_email) params.append('guest_email', filter.guest_email);
    if (filter.hall_id) params.append('hall_id', filter.hall_id.toString());
    if (filter.package_id) params.append('package_id', filter.package_id.toString());
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: BookingListResponse }>(`/admin/bookings?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      bookings: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 예약 상세 조회
   */
  async getBooking(id: number): Promise<Booking> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { booking: Booking } }>(`/admin/bookings/${id}`);
    // return response.data.data.booking;

    throw new Error('Not implemented');
  },

  /**
   * 예약 상태 변경
   */
  async updateBookingStatus(id: number, status: Booking['status']): Promise<Booking> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.patch<{ data: { booking: Booking } }>(`/admin/bookings/${id}/status`, { status });
    // return response.data.data.booking;

    throw new Error('Not implemented');
  },

  /**
   * 예약 취소
   */
  async cancelBooking(id: number, reason?: string): Promise<Booking> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { booking: Booking } }>(`/admin/bookings/${id}/cancel`, { reason });
    // return response.data.data.booking;

    throw new Error('Not implemented');
  },
};

